module.exports = __webpack_public_path__ + "static/media/P2.8d1dd832.jpg";